(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["desktop-menu"] && !Shopify.designMode) return;
  try {
    const boundDropdowns = new WeakSet();
  const initializeDropdownKeyboard = (root) => {
    root.querySelectorAll('.desktop-menu__item--dropdown').forEach((item) => {
      if (boundDropdowns.has(item)) return;
      const launcher = item.querySelector(':scope > .header__nav-link');
      const panel = item.querySelector(':scope > .desktop-menu__submenu');
      if (!launcher || !panel) return;
      boundDropdowns.add(item);
      const open = () => {
        item.removeAttribute('data-keyboard-dismissed');
        panel.inert = false;
        launcher.setAttribute('aria-expanded', 'true');
      };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', () => {
        if (!item.contains(document.activeElement)) {
          launcher.setAttribute('aria-expanded', 'false');
        }
      });
      item.addEventListener('focusin', () => {
        if (!item.hasAttribute('data-keyboard-dismissed')) open();
      });
      item.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (!item.contains(document.activeElement)) {
            item.removeAttribute('data-keyboard-dismissed');
            panel.inert = false;
            launcher.setAttribute('aria-expanded', 'false');
          }
        });
      });
      launcher.addEventListener('click', (event) => {
        if (launcher.getAttribute('href') === '#') event.preventDefault();
        open();
      });
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          item.setAttribute('data-keyboard-dismissed', '');
          panel.inert = true;
          launcher.setAttribute('aria-expanded', 'false');
          launcher.focus();
        } else if (event.target === launcher && (event.key === 'Enter' || event.key === ' ')) {
          if (launcher.tagName === 'BUTTON' || launcher.getAttribute('href') === '#') {
            event.preventDefault();
            open();
          }
        }
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeDropdownKeyboard(document), { once: true });
  } else {
    initializeDropdownKeyboard(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeDropdownKeyboard(event.target));
  } catch(e) { console.error(e); }
})();

})();
